import { useCallback, useEffect, useState } from 'react';
import { messageErreur } from '../../../lib/payments/erreur';

/**
 * Une lecture, et son état. Chaque bloc d'un tableau de bord a la sienne :
 * une vue illisible ne vide pas les autres blocs, et le bloc le DIT plutôt
 * que d'afficher zéro.
 */
export type Lecture<T> =
  | { etat: 'chargement' }
  | { etat: 'erreur'; message: string }
  | { etat: 'pret'; valeur: T };

export function useLecture<T>(lire: () => Promise<T>): [Lecture<T>, () => void] {
  const [lecture, setLecture] = useState<Lecture<T>>({ etat: 'chargement' });
  const relire = useCallback(() => {
    let vivant = true;
    setLecture({ etat: 'chargement' });
    lire().then(
      (valeur) => { if (vivant) setLecture({ etat: 'pret', valeur }); },
      (e) => { if (vivant) setLecture({ etat: 'erreur', message: messageErreur(e, 'Lecture impossible') }); },
    );
    return () => { vivant = false; };
  }, [lire]);
  useEffect(() => relire(), [relire]);
  return [lecture, relire];
}

/** La valeur si la lecture est prête ; `null` si elle a échoué ou attend. */
export function valeurOuNull<T>(l: Lecture<T>): T | null {
  return l.etat === 'pret' ? l.valeur : null;
}
